module.exports = __webpack_public_path__ + "media/bulbitis.59d13860.wav";